module.exports = __webpack_public_path__ + "assets/344a62a9a00938bb1555634dd192ab0c.mp3";